import { Page, useFlashMessages } from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";
import React from "react";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { completeEurekaAuthIfPossible, EUREKA_CLIENT_ID } from "../../../../utilities/eureka";
import { AnimatedDots } from "../../../../components/AnimatedDots";

export const EurekaOAuthCallbackScreen = () => {
  const { authenticate } = useAuthenticationProvider();
  const { showMessage } = useFlashMessages();
  const didRun = React.useRef(false);

  React.useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    (async () => {
      try {
        const { code, codeVerifier, redirectUri } =
          await completeEurekaAuthIfPossible();

        authenticate({
          eureka: {
            code,
            codeVerifier,
            redirectUri,
            clientId: EUREKA_CLIENT_ID,
          },
        })
          .then(() => {
            // redirect to the root of the app after successful authentication
            window.location.href = "/";
          })
          .catch(() => {
            showMessage({
              severity: "error",
              message: "Login failed. Please try again.",
            });
            window.location.href = "/login";
          });
      } catch {
        showMessage({
          severity: "error",
          message: "Login failed. Please try again.",
        });
        window.location.href = "/login";
      }
    })();
  }, []);

  return (
    <Page padding={0} fullWidth scrollable={false}>
      <View
        //@ts-ignore
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
        }}
      >
        <AnimatedDots
          //@ts-ignore
          style={{ textAlign: "center" }}
          text="Please wait while we log you in."
        />
      </View>
    </Page>
  );
};
